module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/rapaport_2x.7cfa92b.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/home/rapaport_2x.png
// module id = dLjV
// module chunks = 41